import * as React from "react";
import { User, UsersAPI } from "./api";
import { Authenticated } from "./components/Authenticated";
import { UserContextProvider } from "./components/context/user";
import Loader from "./components/Loader";
import { Route, Switch, Redirect } from "react-router-dom";
import Menu from "./Menu";
import { Dashboard } from './pages/Dashboard/Dashboard'
import { AlbumDashboard } from "./pages/Album/AlbumDashboard";
import { Statistics } from "./pages/Statistics";
import { CreditDashboard } from "pages/Credit/CreditDashboard";
import { Product } from "pages/Product";
import { Financial } from "pages/Financial";

export default class Main extends React.Component<{}, { user?: User }> {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    public componentDidMount() {
        UsersAPI.getMe().then(user => {
            if (!user.is_admin) {
                window.location.assign('/login')
            }
            this.setState({
                user: user
            })
        })
    }

    public render() {
        return (
            <Authenticated>
                {!this.state.user && <Loader />}
                {this.state.user && <UserContextProvider value={this.state.user}>
                    <Menu>
                        <Switch>
                            <Route path='/dashboard' component={Dashboard} />
                            <Route path='/album' component={AlbumDashboard} />
                            <Route path='/statistics' component={Statistics} />
                            <Route path='/product' component={Product} />
                            <Route path='/financial' component={Financial} />
                            <Route path='/credits' component={CreditDashboard} />
                            <Route render={() => {
                                return <Redirect to='/dashboard' />
                            }} />
                        </Switch>
                    </Menu>
                </UserContextProvider>}
            </Authenticated>
        )
    }
}


// WEBPACK FOOTER //
// ./src/main.tsx